export const SOCIAL_FEED_TITLE: string = "PriceMe Social | The homes everyone’s talking about";

const socialFeedTitle = { SOCIAL_FEED_TITLE };
export default socialFeedTitle;
